import EmptyListNotification from './EmptyListNotification';

export default EmptyListNotification;
